import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
export class PatchWebStoreMetadataFooterDto {
    constructor() {
        this.showLogo = true;
        this.contactsTemplate = '%store.title% | %store.details.restaurantAddress.name% | %store.details.contactInfo.phoneNumber%';
    }
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataFooterDto.prototype, "showLogo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataFooterDto.prototype, "contactsTemplate", void 0);
//# sourceMappingURL=PatchWebStoreMetadataFooterDto.js.map